// ============================================================
// AppLineChart Component
// ============================================================

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
} from 'recharts';
import { tokens } from '@/theme/tokens';
import { Box } from '@mui/material';

export function AppLineChart({ data, xAxisKey, dataKey, color = tokens.colors.primary.main, formatValue }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={tokens.colors.border} />
        <XAxis 
          dataKey={xAxisKey} 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 12, fill: tokens.colors.text.secondary }}
          dy={10}
        />
        <YAxis 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 12, fill: tokens.colors.text.secondary }}
          tickFormatter={(value) => formatValue ? formatValue(value) : value}
        />
        <RechartsTooltip
          contentStyle={{
            backgroundColor: tokens.colors.card,
            borderRadius: tokens.radius.md,
            border: `1px solid ${tokens.colors.border}`,
            boxShadow: tokens.shadows.md,
          }}
          formatter={(value) => [formatValue ? formatValue(value) : value, '']}
        />
        <Line 
          type="monotone" 
          dataKey={dataKey} 
          stroke={color} 
          strokeWidth={3}
          dot={{ r: 4, strokeWidth: 2, fill: tokens.colors.card }}
          activeDot={{ r: 6, strokeWidth: 0, fill: color }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
